import requestInstance from '../../utils/instance-utils';

export const fetchWelcomeVersion = async () => requestInstance.get('welcome');
export const fetchAppConfig = async () => requestInstance.get('app-configs');
